
import { mapState } from 'vuex'
import SingleProductElement from '../../components/product/single'
import { getCategorySortOptions, PRODUCT_SORT } from '../../constants/product-sort'
import ListFilter from '../../components/element-ui/ListFilter'
import SortCategory from '../../components/element-ui/filter/SortCategory'
import { SET_CLEAR_ALL_FILTER, SET_REMOVE_FILTER } from '../../store/store.const'
import { removeVietnameseTones, textToSlug } from '../../utils/utils'
import ShowMoreProduct from '@/components/product/showmore-product.vue'

export default {
  name: 'CategoryLevel3',
  components: { ShowMoreProduct, SingleProductElement, ListFilter, SortCategory },
  // eslint-disable-next-line vue/require-prop-types
  props: ['products', 'isProductSite', 'productLink', 'category', 'page', 'lastPage', 'total', 'categoryParent', 'listDataFilter', 'listFilter', 'listFilterAdvance', 'listDataFilterAdvance', 'nextPage'],
  data() {
    return {
      slug: this.$route.params.slug,
      type_sort: PRODUCT_SORT.POPULAR,
      perPage: 23,
      dataFilter: [],
      currentPage: 1,
      showModalCategory: false,
      hideModalCategory: false
    }
  },
  computed: {
    ...mapState('filter', {
      clearAllFilter: state => state.clearAllFilter
    }),
    list_sort() {
      return getCategorySortOptions(key => this.$t(key))
    },
    paramUrl() {
      let query = ''
      const filter = []
      this.dataFilter.forEach(data => {
        filter.push(`${data.type}=${data.list.join(',')}`)
      })
      filter.push(`order_by=${this.normalizedOrderBy(this.type_sort)}`)
      if (this.currentPage > 1) {
        filter.push(`page=${this.currentPage}`)
      }
      query = filter.join('&')

      return query
    },
    hideFooter() {
      return this.$store.state.hideFooter
    }
  },
  watch: {
    type_sort() {
      this.currentPage = 1
      this.type_sort = this.normalizedOrderBy(this.type_sort)
      this.syncUrl()
      this.$emit('change', this.buildSearchParams({ page: this.currentPage }))
    },
    currentPage() {
      if (!this.$device.isMobile) {
        this.syncUrl()
      }
    }
  },
  mounted() {
    this.convertDataUrl()
    window.onscroll = () => {
      const bottomOfWindow = document.documentElement.offsetHeight - (document.documentElement.scrollTop + window.innerHeight) < 100
      if (bottomOfWindow && this.hideFooter && this.$device.isMobile && this.nextPage) {
        this.changePage(this.page + 1)
      }
    }
  },
  methods: {
    hasOrderByValue(value) {
      return value !== undefined && value !== null && value !== ''
    },
    normalizedOrderBy(value) {
      const orderBy = Number(value)
      return this.hasOrderByValue(value) && Number.isFinite(orderBy) ? orderBy : PRODUCT_SORT.POPULAR
    },
    buildSearchParams(extraParams = {}) {
      const search = {
        page: this.currentPage,
        per_page: parseInt(this.perPage),
        order_by: this.normalizedOrderBy(this.type_sort),
        ...extraParams
      }

      if (this.keyword) {
        search.search = this.keyword
      }

      this.dataFilter.forEach(data => {
        search[data.type] = data.list.join(',')
      })

      return search
    },
    syncUrl(useReplace = false) {
      const link = this.isProductSite ? this.productLink : this.category.link
      const method = useReplace ? 'replaceState' : 'pushState'
      history[method]({}, null, `${link}?${this.paramUrl}`)
    },
    changeDataFilter(value) {
      this.perPage = 23
      const data = []
      let check = true
      this.currentPage = 1
      this.dataFilter.forEach(filter => {
        if (filter.type === value.type) {
          if (value.value.length > 0) {
            data.push(value)
          }
          check = false
        } else {
          data.push(filter)
        }
      })
      if (check) data.push(value)
      this.dataFilter = data
      this.syncUrl()
      this.$emit('change', this.buildSearchParams({ page: 1 }))
    },
    removeFilter(type, data) {
      this.$store.commit(SET_REMOVE_FILTER, { type, value: data })
    },
    clearFilter() {
      this.$store.commit(SET_CLEAR_ALL_FILTER, !this.clearAllFilter)
    },
    changeToLink(link) {
      this.$router.push(link)
    },
    convertData(category) {
      const children = []
      category.children.forEach(cat => {
        children.push({
          id: cat.id,
          name: cat.name,
          link: '/category/' + textToSlug(removeVietnameseTones(cat.name)) + '.' + cat.id,
          image: cat.image_url,
          image_thumb_url: cat.image_thumb_url
        })
      })
      return children
    },
    convertDataUrl() {
      const query = this.$route.query
      this.type_sort = this.normalizedOrderBy(query.order_by)
      if (query.page) {
        this.currentPage = Number(query.page)
      }
      if (!this.hasOrderByValue(query.order_by)) {
        this.syncUrl(true)
      }
    },
    async changePage(page) {
      this.currentPage = page
      await this.$emit('change', this.buildSearchParams({ page: this.currentPage }))
    },
    closeModalCategory() {
      this.showModalCategory = false
    },
    clickShowMore() {
      this.currentPage = this.page + 1
      const filterData = this.buildSearchParams({ page: this.currentPage })
      if (!this.$device.isMobile) {
        this.syncUrl()
      }
      this.$emit('loadMoreProduct', filterData)
    }
  }
}
